export default "__VITE_ASSET__a92c94fd__"